"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var blank_1 = require("./images/blank");
var ErrorComponent = function (props) {
    var cls = props.cls;
    var src = props.src ? props.src : blank_1.default;
    var style = props.style ? props.style : { margin: "100px 0", width: "100%", height: "100%" };
    return React.createElement("div", { className: cls, style: style },
        React.createElement("img", { src: src }));
};
exports.default = ErrorComponent;
